// extracted by mini-css-extract-plugin
export default {"block":"nk","flex":"ok","radio":"pk","label":"qk","error":"rk","extra":"sk"};